import { useCallback, useEffect, useRef, useState } from "react";

export default function useSafeState(initialState) {
  const [state, setState] = useState(initialState);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const setSafeState = useCallback((value) => {
    if (!mountedRef.current) return;
    setState(value);
  }, []);

  return [state, setSafeState];
}
